import React, { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";
import { Navbar } from "@/components/Navbar";
import { ComplianceFooter } from "@/components/Compliance";
import { ShieldAlert } from "lucide-react";

export default function CompliancePage() {
  const [course, setCourse] = useState(null);
  const [blocks, setBlocks] = useState([]);
  useEffect(() => {
    api.get("/course").then((r) => setCourse(r.data.course)).catch(() => {});
    api.get("/compliance").then((r) => setBlocks(r.data)).catch(() => {});
  }, []);
  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <Navbar />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-10" data-testid="compliance-page">
        <div className="flex items-center gap-3 mb-6">
          <ShieldAlert className="w-7 h-7 text-amber-600" />
          <h1 className="font-display text-3xl font-bold tracking-tight text-slate-900">Disclaimer & Compliance</h1>
        </div>
        {course?.disclaimer && (
          <div className="rounded-xl border border-slate-200 bg-white p-6 mb-6">
            <p className="text-sm text-slate-700 leading-relaxed whitespace-pre-line">{course.disclaimer}</p>
          </div>
        )}
        <div className="space-y-4">
          {blocks.map((b) => (
            <div key={b.id} className="rounded-xl border border-slate-200 bg-white p-6">
              <p className="text-xs font-semibold uppercase tracking-[0.15em] text-slate-400 mb-1">{b.display_location}</p>
              <h2 className="font-display font-semibold text-slate-900">{b.title}</h2>
              <p className="text-sm text-slate-600 mt-2 leading-relaxed">{b.body}</p>
            </div>
          ))}
        </div>
      </main>
      <ComplianceFooter />
    </div>
  );
}
